<template>
  <div>
    <div>
      <div class="max-w-5xl mx-auto">
        <div v-if="action == 'create'">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Crea categoria
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Crea le categorie per personalizzare la tua offerta.
          </p>
        </div>
        <template v-if="action == 'update'">
            <div class="flex flex-wrap items-center justify-between -mt-4 -ml-4 sm:flex-no-wrap">
              <div class="mt-4 ml-4">
                <h3 class="text-lg font-medium leading-6 text-gray-900">
                  {{form.name}}
                </h3>
              </div>
              <div class="flex-shrink-0 mt-4 ml-4">
                <span class="inline-flex rounded-md shadow-sm">
                  <button @click="deleteModal" type="button" class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-red-700 transition duration-150 ease-in-out bg-white border border-transparent border-red-700 rounded-md hover:bg-red-200 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200">
                    Elimina Categoria
                  </button>
                </span>
              </div>
          </div>
        </template>
      </div>

      <div class="max-w-5xl mx-auto mt-5">
        <form v-on:submit.prevent="onSubmit">
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6">
                  <label
                    for="name"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Nome</label
                  >
                  <div v-for="(translation, index) in form.checked_languages" :key="translation.code">
                        <div class="flex mt-1 rounded-md shadow-sm" :class="index > 0 ? 'mt-3' : ''">
                        <span class="inline-flex items-center justify-center w-10 px-2 text-center text-gray-500 border border-r-0 border-gray-300 rounded-l-md bg-gray-50 sm:text-sm">
                          {{translation.code}}
                        </span>
                        
                        <input
                        :class="translationsError['translations.'+translation.code].length > 0 ? 'border-red-300' : ''"
                        v-model="translations[translation.code]"
                        :id='"language_"+translation.id'
                        :name='"language_"+translation.id'
                          
                          class="flex-1 block w-full px-3 py-2 rounded-none form-input rounded-r-md sm:text-sm sm:leading-5">
                        
                         <button @click="copyText(translations[translation.code])" v-if="form.checked_languages.length > 1 && index === 0" type="button" class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out border border-gray-300 rounded-r-md bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700">
                          <svg class="w-5 h-5 text-gray-400 transform rotate-180" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h5a1 1 0 000-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3zM13 16a1 1 0 102 0v-5.586l1.293 1.293a1 1 0 001.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 101.414 1.414L13 10.414V16z"></path>
                          </svg>
                          <span class="ml-2 ">Copia
                          </span>
                        </button>
                      </div>
                      <p class="mt-1 text-xs text-red-600" v-if="translationsError['translations.'+translation.code]">
                        {{ translationsError['translations.'+translation.code][0] }}
                      </p>
                      
                  </div>
                  <label
                    class="block mt-4 text-sm font-medium leading-5 text-gray-700"
                    >Icona</label
                  >
                    <div class="relative mt-1 rounded-md shadow-sm">
                      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">

                        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400"  fill="currentColor" viewBox="0 0 24 24"><path class="heroicon-ui" d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"/></svg>

                      </div>
                      <input v-model="serchicon" class="block w-full pl-10 form-input sm:text-sm sm:leading-5" placeholder="Cerca icona" />
                    </div>
                  <div class="flex flex-wrap h-64 mt-2 overflow-y-auto border border-gray-200 rounded-md">
                    
                  <div v-for="(icon) in filterIcons" :key="icon.id" class="mx-1.5 " >
                      <label :for="'icon_'+icon.id" class="">
                        <input :id="'icon_'+icon.id"
                        v-model="iconSelected"
                        type="radio" :value="icon.id"
                        class="hidden">
                        <div class="relative flex items-center w-20 h-20 rounded-full cursor-pointer" :class="[iconSelected === icon.id ? 'border-2 shadow-sm bg-gray-100' : '', locationColor != null ?  'border-' +locationColor.primary :  'border-black' ]">
                            <img :for="'icon_'+icon.id"
                            v-lazy="icon.url"
                            class="block w-12 h-12 mx-auto">
                            <div class="absolute inset-0 block w-10 h-10 mx-auto top-3">
                            </div>
                        </div>
                    </label>
                  </div>
                  </div>
                </div>
              </div>
              <p class="mt-2 text-sm text-gray-800"><a href="mailto:info@menubyte.it?subject=Richiesta icona">Non trovi l'icona per la tua categoria? <span class="font-bold text-indigo-700">Contattaci</span></a></p>
            </div>


            <div class="px-4 py-3 text-right bg-gray-50 sm:px-6 bg-opacity-90">
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="inline-flex justify-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700"
                >
                  <template v-if="action == 'update'">
                    Salva
                  </template>

                  <template v-if="action == 'create'">
                    Crea
                  </template>
                  
                </button>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
    <modal key="" v-show="modal.show" :event="modal.event" :icon="modal.icon" :buttonText="modal.buttonText" :buttonClass="modal.buttonClass" :eventclose="modal.eventclose" :title="modal.title" :description="modal.description"></modal>

  </div>
</template>

<script>
import CategoryService from "../apis/CategoryService";
import IconService from "../apis/IconService";
import Modal from "../components/Modal";

export default {
  props: {
    id: Number,
    idcategory: Number
  }, 
  components: {
    Modal
  },
  data() {
    return {
      form: {},
      formToSend: {},
      formErrors: {},
      translations: {},
      translationsError: {},
      icons: [],
      iconSelected: null,
      locationColor: {},
      action: this.$route.meta.action,
      modal:{
        type: "",
        show: false,
        title: "",
        description: "",
        event: "",
        eventclose: "",
        icon: "",
        buttonText: "",
        buttonClass: "",
      },
      serchicon: ""
    };
  },
  mounted() {
    
    if(this.action == "create"){      
      CategoryService.createCategoryNew(this.id).then(response => {
        let data = response.data.data;
        for (let i = 0; i < data.checked_languages.length; i++) {
          let code = data.checked_languages[i].code;
          this.$set(this.translations,  code, "");
          this.$set(this.translationsError, 'translations.' + data.checked_languages[i].code, [])
        }
        this.form = response.data.data;
      });
    }
    

    if (this.action == "update") {
      CategoryService.getCategory(this.id, this.idcategory).then(response => {
       let data = response.data.data;
        for (let i = 0; i < data.checked_languages.length; i++) {
          let code = data.checked_languages[i].code;
          this.$set(this.translations,  data.checked_languages[i].code, this.getTraslation(data.translations, code))
          this.$set(this.translationsError, 'translations.' + data.checked_languages[i].code, [])
        }
        this.form = response.data.data;
        this.iconSelected = response.data.data.category_icon_id;

        this.$root.$on('clickDeleteCategory'+ this.form.id, () => {
          this.deleteCategory();
        });

        this.$root.$on('clickCloseModalCategory'+ this.form.id, () => {
          this.modal.show = false;
        });

      });
    }

    IconService.getIcons().then(response => {
      this.icons = response.data.data;
    });

/*
    let location = this.$store.getters.locationById(42);
    if (location.length == 1){
      this.locationColor = location[0].color;
    }
    */
  },
  created(){

  },
  computed:{
    filterIcons: function() {
      return this.icons.filter( x => x.keywords.includes(this.serchicon));
    }
  },
  methods: {
    getTraslation: function(list, code){
      let result = list.filter(x => x.locale == code);
      if (result.length > 0) {
        return result[0].name;
      }
      return "";
    },
    showLenguageErrors: function(errors){
      let keys = Object.keys(errors);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        if (this.translationsError[key] != undefined) {
          this.translationsError[key].push(errors[key][0]);
        }
      }
    },
    onSubmit: function() {
      if (this.action == "create"){
        this.formToSend.translations = this.translations;
        this.formToSend.category_icon_id = this.iconSelected;
        this.$store.dispatch("updateSpinner", true);
          
        CategoryService.createCategory(this.id, this.formToSend)
          .then(response => {
            console.log(response);
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Categoria creata", description: ""});
            this.$router.push({ name: "Categories", props:{id : this.id} }).catch(err => {console.log(err)});
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
            this.showLenguageErrors(error.response.data.errors);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Correggi gli errori", description: "", succes: false});
          }
          this.$store.dispatch("updateSpinner", false);
        });
      }

      if(this.action == "update"){

        let keys = Object.keys(this.translationsError);
        for(let i=0; i<keys.length; i++){
          let key = keys[i];
          this.translationsError[key] = [];
        }

        this.formToSend.translations = this.translations;
        this.formToSend.category_icon_id = this.iconSelected;
        this.$store.dispatch("updateSpinner", true);
        CategoryService.updateCategory(this.id, this.idcategory, this.formToSend)
          .then(() => {
            this.$store.dispatch("updateSpinner", false);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Categoria aggiornata", description: "", succes: true});
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
            this.showLenguageErrors(error.response.data.errors);
            this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Correggi gli errori", description: "", succes: false});
          }
          this.$store.dispatch("updateSpinner", false);
        });
      }
    },
    copyText: function(text){
      for (let i = 0; i < this.form.checked_languages.length; i++) {
        let code = this.form.checked_languages[i].code;
        if(this.translations[code] === ""){
          this.translations[code] = text;
        }
      }
    },
    deleteModal:function(){
      this.modal.event = 'clickDeleteCategory' + this.form.id;
      this.modal.eventclose = 'clickCloseModalCategory' + this.form.id;
      this.modal.title = "Sei sicuro?";
      this.modal.description = "Cancellando la categoria '"+this.form.name+"' verranno ELIMINATI TUTTI i piatti in essa contenuti.";
      this.modal.icon = "alert";
      this.modal.buttonText = "Elimina";
      this.modal.buttonClass = "bg-red-600 hover:bg-red-500  focus:border-red-700 focus:shadow-outline-red";
      this.modal.show = true;
    },
    deleteCategory: function(){
        this.$store.dispatch('updateSpinner', true);
        this.modal.show = false;

         CategoryService.deleteCategory(this.id, this.idcategory)
        .then(() => {
          this.$store.dispatch("updateSpinner", false);
          this.$router.push({ name: "Categories", params: { id: this.id} }).catch(err => {console.log(err)});
          this.$store.dispatch("addNotification", {id: Math.floor(Math.random() * 100000), title : "Categoria eliminata", description: ""});
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.formErrors = error.response.data.errors;
          }
        });
    },
  }
};
</script>
